export function applyVariant(card, variant) {
  const set = (name, value) => {
    const node = card.querySelector('[data-campaign-' + name + ']')
    if (node) node.textContent = value || ''
    return node
  }
  set('price', variant.price)
  const compare = set('compare', variant.compare)
  if (compare) compare.hidden = !variant.compare
  const saving = set('saving', variant.saving)
  if (saving) saving.hidden = !variant.saving
  const input = card.querySelector('[data-campaign-variant-id]')
  if (input) input.value = String(variant.id)
  const image = card.querySelector('[data-campaign-image]')
  if (image && variant.image) {
    image.setAttribute('src', variant.image)
    image.removeAttribute('srcset')
    image.setAttribute('alt', variant.alt || '')
  }
  const button = card.querySelector('[data-campaign-submit]')
  if (button) {
    button.disabled = !variant.available
    button.textContent = variant.available
      ? button.dataset.availableLabel
      : button.dataset.unavailableLabel
  }
}
export function mountProductGrid(root) {
  const abort = new AbortController()
  const disconnectDrag = [...root.querySelectorAll('.campaign-card__variants')].map(
    mountVariantDrag,
  )
  const cards = new Map()
  for (const card of root.querySelectorAll('[data-campaign-card]')) {
    try {
      const variants = JSON.parse(card.querySelector('[data-campaign-variants]').textContent)
      cards.set(card, variants)
      card.setAttribute('data-enhanced', '')
    } catch {
      // Keep the native variant select and product form available.
    }
  }
  root.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest('[data-campaign-variant]')
      if (!input) return
      const card = input.closest('[data-campaign-card]')
      const variant = cards.get(card)?.find((item) => String(item.id) === input.value)
      if (!variant) return
      applyVariant(card, variant)
      for (const radio of card.querySelectorAll('[data-campaign-variant]'))
        radio.checked = radio === input
    },
    { signal: abort.signal },
  )
  root.addEventListener(
    'shopify:block:select',
    (event) => {
      const card = event.target.closest('[data-campaign-card]')
      if (card) card.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' })
    },
    { signal: abort.signal },
  )
  return () => {
    abort.abort()
    disconnectDrag.forEach((disconnect) => disconnect())
    for (const card of cards.keys()) card.removeAttribute('data-enhanced')
    cards.clear()
  }
}
// Touch keeps native scrolling. Mouse dragging must not select the released SKU.
export function mountVariantDrag(rail) {
  const abort = new AbortController()
  const options = { signal: abort.signal }
  let pointer
  let dragged = false
  let suppressClick = false
  rail.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return
      pointer = { id: event.pointerId, x: event.clientX, scroll: rail.scrollLeft }
      dragged = false
      suppressClick = false
    },
    options,
  )
  rail.addEventListener(
    'pointermove',
    (event) => {
      if (!pointer || event.pointerId !== pointer.id) return
      const distance = event.clientX - pointer.x
      if (!dragged && Math.abs(distance) < 5) return
      if (!dragged) {
        dragged = true
        rail.setPointerCapture(pointer.id)
        rail.setAttribute('data-dragging', '')
      }
      event.preventDefault()
      rail.scrollLeft = pointer.scroll - distance
    },
    options,
  )
  const finish = (event) => {
    suppressClick = event?.type === 'pointerup' && dragged
    if (pointer && rail.hasPointerCapture(pointer.id)) rail.releasePointerCapture(pointer.id)
    pointer = undefined
    dragged = false
    rail.removeAttribute('data-dragging')
  }
  rail.addEventListener('pointerup', finish, options)
  rail.addEventListener('pointercancel', finish, options)
  rail.addEventListener(
    'lostpointercapture',
    () => {
      pointer = undefined
      rail.removeAttribute('data-dragging')
    },
    options,
  )
  rail.addEventListener(
    'pointerleave',
    () => {
      if (!dragged) pointer = undefined
    },
    options,
  )
  rail.addEventListener('dragstart', (event) => event.preventDefault(), options)
  rail.addEventListener(
    'click',
    (event) => {
      if (!suppressClick || event.detail === 0) {
        suppressClick = false
        return
      }
      event.preventDefault()
      event.stopImmediatePropagation()
      suppressClick = false
    },
    { ...options, capture: true },
  )
  return () => {
    finish()
    abort.abort()
  }
}
if (typeof customElements !== 'undefined' && !customElements.get('campaign-product-grid')) {
  customElements.define(
    'campaign-product-grid',
    class extends HTMLElement {
      connectedCallback() {
        this.disconnectGrid ??= mountProductGrid(this)
      }
      disconnectedCallback() {
        this.disconnectGrid?.()
        this.disconnectGrid = undefined
      }
    },
  )
}
